(() => {
  const ROOT = '.product__description';
  const compact = (node) => (node.textContent || '').replace(/\s+/g, ' ').trim();
  const heading = (text) => /^more\s+colou?rs?\s+avail(?:a|a?i?)ble\s*[:!]?$/i.test(text);
  const initialized = new WeakSet();

  function clearLeadingSpace(grid, root) {
    let current = grid;
    while (current && current !== root) {
      // The approved 8px boundary is deliberate, including inline spacer spans.
      if (current.classList.contains('custom-description-color-media-gap-v1')) break;
      let previous = current.previousSibling;
      while (previous) {
        if (previous.nodeType === Node.ELEMENT_NODE
          && previous.classList.contains('custom-description-color-media-gap-v1')) return;
        if (compact(previous) || (previous.nodeType === Node.ELEMENT_NODE
          && (previous.matches('img, picture, table, details, video, iframe, input, button')
            || previous.querySelector('img, picture, table, details, video, iframe, input, button')))) return;
        const before = previous.previousSibling;
        if (previous.nodeType === Node.TEXT_NODE) {
          // Keep original text, but suppress the line box created by a leading NBSP.
          const hidden = root.ownerDocument.createElement('span');
          hidden.className = 'custom-more-colors-empty-row-v1';
          previous.before(hidden);
          hidden.append(previous);
        } else if (previous.nodeType === Node.ELEMENT_NODE) {
          previous.classList.add('custom-more-colors-empty-row-v1');
        }
        previous = before;
      }
      current.classList.add('custom-more-colors-leading-path-v1');
      current = current.parentElement;
    }
  }

  function preserveMediaBoundary(grid) {
    const image = grid.querySelector('img');
    const boundary = image?.closest('.custom-description-color-media-gap-v1');
    if (boundary && grid.contains(boundary) && boundary !== grid) {
      grid.classList.add('custom-description-gap-before-v1', 'custom-description-color-media-gap-v1');
    }
  }

  function apply(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const existing = root.querySelectorAll('.custom-more-colors-grid-v1');
    if (existing.length) { existing.forEach((grid) => { clearLeadingSpace(grid, root); preserveMediaBoundary(grid); }); return; }
    const walker = root.ownerDocument.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
    const groups = [];
    let group = null;
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.nodeType === Node.ELEMENT_NODE && node.matches('details, table')) group = null;
      if (node.parentElement?.closest('details, table')) continue;
      if (node.nodeType === Node.TEXT_NODE) {
        if (heading(compact(node))) { group = []; groups.push(group); }
        else if (/sizechart/i.test(compact(node).replace(/\s+/g, ''))) group = null;
      } else if (group && node.matches('img')) group.push(node);
    }
    for (const images of groups) {
      if (!images.length) continue;
      const doc = root.ownerDocument;
      const grid = doc.createElement('span');
      grid.className = 'custom-more-colors-grid-v1';
      const firstLink = images[0].closest('a');
      const firstUnit = firstLink && root.contains(firstLink) ? firstLink : images[0];
      firstUnit.before(grid);
      const oldParents = new Set();
      for (const image of images) {
        let parent = image.parentElement;
        while (parent && parent !== root) { oldParents.add(parent); parent = parent.parentElement; }
        const link = image.closest('a');
        let unit = image;
        if (link && root.contains(link)) {
          if (link.querySelectorAll('img').length === 1 && !compact(link)) unit = link;
          else {
            // Preserve each picture's exact link attributes, including shared legacy anchors.
            unit = link.cloneNode(false);
            unit.append(image);
          }
        }
        const cell = doc.createElement('span');
        cell.className = 'custom-more-colors-grid-cell-v1';
        cell.append(unit);
        grid.append(cell);
      }
      clearLeadingSpace(grid, root);
      preserveMediaBoundary(grid);
      // Original row wrappers remain in the DOM; only empty presentation rows collapse.
      for (const parent of oldParents) {
        if (grid.contains(parent) || parent.contains(grid)) continue;
        if (!compact(parent) && !parent.querySelector('img, picture, video, iframe, table, details, input, button')) {
          parent.classList.add('custom-more-colors-empty-row-v1');
        }
      }
    }
  }

  const refresh = () => document.querySelectorAll(ROOT).forEach(apply);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
  document.addEventListener('shopify:section:load', refresh);
})();
